import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { BASE_URL } from '../../appConfig';
import { getAuthToken } from '../AuthService';

// Create a single axios instance for the application
const apiClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
});

// Request interceptor for adding auth token
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = getAuthToken();

    if (token && config.url?.includes('/payment/verify') || config.url?.includes('/book')) {
      config.headers.set('Authorization', `Bearer ${token}`);
    }
    return config;
  },
  (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling common responses
apiClient.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response;
  },
  (error: AxiosError): Promise<AxiosError> => {
    // Handle global error scenarios
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const status = error.response.status;
      
      if (status === 401) {
        // Handle unauthorized access (e.g., token expired)
        // You might want to redirect to login or refresh token
        console.log('Unauthorized access. Redirecting to login...');
        // Example: localStorage.removeItem('auth_token');
        // Example: window.location.href = '/login';
      } else if (status === 403) {
        // Handle forbidden access
        console.log('Access forbidden');
      } else if (status === 500) {
        // Handle server errors
        console.log('Server error occurred');
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.log('Network error. No response received from server.');
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error setting up the request:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
